module.exports = __webpack_public_path__ + "img/google-slides.fefcb68f.png";